import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export enum MeetingPrepTab {
  MY = "my",
}

interface MeetingPrepStore {
  activeTab: MeetingPrepTab;
  setActiveTab: (tab: MeetingPrepTab) => void;
}

export const useMeetingPrepList = create(
  persist<MeetingPrepStore>(
    (set) => ({
      activeTab: MeetingPrepTab.MY,
      setActiveTab: (tab: MeetingPrepTab) => {
        set({ activeTab: tab });
      },
    }),
    {
      name: "meetingPrepListStore",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
